import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "../../shared/shared.module";

import { UserMenuComponent } from "./user-menu/user-menu.component";
import { ProfessionalMenuComponent } from "./professional-menu/professional-menu.component";
import { MenuHeaderComponent } from "./menu-header/menu-header.component";
import { MenuFooterComponent } from "./menu-footer/menu-footer.component";
import { MenuItemComponent } from "./menu-item/menu-item.component";
import { ScreenHeader } from "../../components/screen-header/screen-header";
import { LanguageComponent } from "../../components/language-dropdown/language-dropdown.component";
import { OrganizationDropdown } from "../../components/organization-dropdown/organization-dropdown.component";
import { TruncatePipe } from "./truncate/truncate";
import { RouterModule } from "@angular/router";
import { AccessControlDirective } from "app/directives/access-control.directive";
import { TopNavbarMenuComponent } from './top-navbar-menu/top-navbar-menu.component';


@NgModule({
	declarations: [
		UserMenuComponent,
		ProfessionalMenuComponent,
		MenuHeaderComponent,
		MenuFooterComponent,
		MenuItemComponent,
		ScreenHeader,
		LanguageComponent,
		OrganizationDropdown,
		TruncatePipe,
		AccessControlDirective,
  		TopNavbarMenuComponent
	],
	imports: [CommonModule, RouterModule, SharedModule],
	providers: [],
	exports: [
		UserMenuComponent,
		ProfessionalMenuComponent,
		MenuHeaderComponent,
		MenuFooterComponent,
		MenuItemComponent,
		ScreenHeader,
		LanguageComponent,
		OrganizationDropdown,
		TruncatePipe,
		AccessControlDirective,
		TopNavbarMenuComponent
	],
})
export class MenuModule {}
